module.exports = __webpack_public_path__ + "img/pluto166.de86395e.jpg";